import { useLocation, useNavigate } from 'react-router-dom';

import { isMenuLinkSelected } from 'src/Components/Menu/isMenuLinkSelected';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

import { isMenuCollapsible, isMenuHeader, isMenuLink } from '../Menu.config';
import { MenuCollapsible } from '../MenuCollapsible';
import { MenuHeader } from '../MenuHeader';
import { MenuLink } from '../MenuLink';

import { Props } from './MenuItem.types';

const MenuItem = ({ item, onClick }: Props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const assetId = useCurrentAssetId();

  const isSelected = (itemLink?: string): boolean =>
    isMenuLinkSelected(location.pathname, itemLink);

  if (isMenuLink(item)) {
    const link = item.getLink?.() ?? (assetId ? item.getLinkWithAssetId?.(assetId) : undefined);

    return (
      <MenuLink
        label={item.label}
        icon={item.icon}
        selected={isSelected(link)}
        onClick={() => {
          if (link) navigate(link);
          onClick();
        }}
      />
    );
  } else if (isMenuCollapsible(item)) {
    return (
      <MenuCollapsible
        label={item.label}
        storageKey={item.storageKey}
        items={item.items}
        onItemClick={onClick}
      />
    );
  } else if (isMenuHeader(item)) {
    return <MenuHeader label={item.label} />;
  }
};

export default MenuItem;
